import React from "react";
import PropTypes from "prop-types";

const Price = ({ price, itemName, openPriceDetail }) => {
  const vendors = price && Object.keys(price);

  return price ? (
    <tr>
      <td>{itemName}</td>
      {vendors.map((vendor) => {
        const vendorOffer = price[vendor];
        return vendorOffer ? (
          <td
            onClick={() => openPriceDetail(vendorOffer)}
            class={`${vendorOffer.is_best_price && "table-success"} ${!vendorOffer.is_active && "table-danger"} ${
              vendorOffer.normalized_price_unit && "pointer"
            }`}
          >
            {!vendorOffer.is_active && (
              <div className="price-inactive">{"This price is inactive due to a better offer from the same vendor in another list"}</div>
            )}
            {`${vendorOffer.normalized_price} / ${vendorOffer && vendorOffer.normalized_price_unit}`}
          </td>
        ) : (
          <td>{"-"}</td>
        );
      })}
    </tr>
  ) : (
    <div></div>
  );
};

const PricesComparison = ({ pricesList, openPriceDetail }) => {
  return (
    pricesList && (
      <tbody>
        {pricesList.map((price) => {
          return <Price price={price.offer_item_prices} itemName={price.name} key={price.id} openPriceDetail={openPriceDetail} />;
        })}
      </tbody>
    )
  );
};

PricesComparison.propTypes = {
  pricesList: PropTypes.array.isRequired,
};

export default PricesComparison;
